<template>
  <div class="sass-text-search">
    <div class="sass-text-search__inner">
      <input
        :value="value"
        type="text"
        :placeholder="placeholder"
        class="sass-text-search__input"
        @input="$emit('input', $event.target.value)"
      />
      <i class="iconoir-search sass-text-search__icon"></i>
      <a class="sass-text-search__clear" @mousedown="$emit('input', '')">
        <i class="iconoir-cancel"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Search...',
    },
  },
}
</script>
